import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { captureRef, grantConsent, denyConsent, trackRefClick, trackEvent, hasConsent } from "@/lib/tracking";

export default function VisitorTracker() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    captureRef();
    const choice = localStorage.getItem("noxway_consent");
    if (!choice) setShow(true);
    else if (choice === "yes") {
      trackRefClick();
      trackEvent("page_view");
    }
    // mark product view for hesitation rescuer + intent scoring
    const target = document.querySelector("#buy");
    if (target) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          sessionStorage.setItem("noxway_product_viewed", "1");
          trackEvent("product_view");
          observer.disconnect();
        }
      }, { threshold: 0.3 });
      observer.observe(target);
      return () => observer.disconnect();
    }
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 left-5 z-50 max-w-sm card-glow-border rounded-2xl p-5 bg-[#0f1117]/95 backdrop-blur-xl"
          data-testid="consent-banner"
        >
          <div className="flex items-start gap-3">
            <ShieldCheck size={20} className="text-[#f97316] shrink-0 mt-0.5" />
            <div>
              <p className="text-sm text-slate-200 font-semibold mb-1">Privacy-first analytics</p>
              <p className="text-xs text-slate-400 leading-relaxed mb-4">
                May we use anonymous, first-party visit signals to improve your experience? No personal data is
                collected unless you check out or contact us.
              </p>
              <div className="flex gap-2.5">
                <button
                  onClick={() => { grantConsent(); setShow(false); }}
                  data-testid="consent-accept"
                  className="font-tech text-[10px] tracking-[0.15em] uppercase px-4 py-2 rounded-full bg-gradient-to-r from-[#f97316] to-[#ea580c] text-white"
                >
                  Allow
                </button>
                <button
                  onClick={() => { denyConsent(); setShow(false); }}
                  data-testid="consent-decline"
                  className="font-tech text-[10px] tracking-[0.15em] uppercase px-4 py-2 rounded-full border border-white/20 text-slate-300 hover:border-white/50 transition-colors"
                >
                  Decline
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
